import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import '../../assets/css/scss/main.css';
import * as icons from 'react-bootstrap-icons';
import RightSideBanner from './RightSideBanner';
import { ForgetPasswordEmailSend } from '../../redux/auth-reducer/auth-service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { emailError, isValidEmail } from '../../utils/helper/validation';
import { BackButton } from '../../CommonComponent/BackButton';


function ForgotPassword() {
  const [validated, setValidated] = useState(false);
  const [Email, setEmail] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const handleEmail = (e) => {
     setEmail(e.target.value)
  }

  useEffect(() => {
    if (isButtonDisabled) {
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
    }
  }, [isButtonDisabled])


  const handleSubmit = async (event) => {
    event.preventDefault();
    // #275: an empty or malformed email is reported on the form and nothing is sent.
    if (!event.currentTarget.checkValidity() || !isValidEmail(Email)) {
      setValidated(true);
      return;
    }
    // #275: the server's answer is its toast alone, and the email stays as typed; clearing it
    // used to show "empty field" under it too.
    setValidated(false);
    setIsButtonDisabled(true);

    const data = {
      "email": Email
    }

    await ForgetPasswordEmailSend(data).then((res) => {
      if (res?.status == true) {
        toast.success(res?.message);
      } else {
        toast.error(res?.message)
      }
    });
  };



  return (
    <>
      <div className='grop-section'>
        <div className='icon-back'>
          {/* #278: was a link to /Login that reloaded the whole app. */}
          <BackButton />
        </div>
        <div className='group-reg'>

          <div className='item'>
            <div className='inner-item'>
              <div className='form-contnet'>
                <h1 className='heading'>Forgot Password</h1>
              </div>
              <Form noValidate validated={validated} className='Login-form' onSubmit={handleSubmit}>
                <Row className="mb-3">

                  <Form.Group as={Col} md="12" controlId="validationCustomFristname">
                    <Form.Label>Email</Form.Label>
                    <InputGroup hasValidation>
                      <icons.Person className='persion-icon' />


                      <Form.Control className='email-input'
                        type="email"
                        name='Email'
                        value={Email}
                        onChange={handleEmail}
                        placeholder="Enter your email"
                        aria-describedby="inputGroupPrepend"
                        required
                        // #274: type="email" alone accepts "a@b".
                        isInvalid={validated && !!Email && !isValidEmail(Email)}
                      />

                      <Form.Control.Feedback type="invalid">
                        {emailError(Email)}
                      </Form.Control.Feedback>
                      {/* #300: the hint sits where the error does, and the error replaces it. */}
                      {!(validated && (!Email || !isValidEmail(Email))) && (
                        <Form.Text className="form-hint w-100">
                          Enter your email to recover your password
                        </Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Col md="12 ">
                    <Button type="submit" disabled={isButtonDisabled} className='submit'>Submit</Button>
                  </Col>



                </Row>
              </Form>

            </div>
          </div>
          <RightSideBanner />
        </div>
      </div>
    </>
  )
}
export default ForgotPassword;